import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { SearchAssistant } from 'src/types/searchAssistant'

import { createSearchCache } from '@helpers'

import { validateDuplicateTitle } from './validateDuplicateTitle'

const viewProp = 'title'

interface SearchAssistantTitleDuplicateValidationProps {
  // TODO(isilanov): Отвязаться от внешних данных и получать их тут из кэща
  allSearchAssistants: SearchAssistant[]
  defaultValue: string
}

export const useSearchAssistantTitleDuplicateValidation = (
  props: SearchAssistantTitleDuplicateValidationProps
) => {
  const { allSearchAssistants, defaultValue } = props

  const { t } = useTranslation()

  const viewCache = useMemo(
    () => createSearchCache(allSearchAssistants || [], viewProp),
    [allSearchAssistants]
  )

  useEffect(() => {
    return () => {
      viewCache.clearCache()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    validate: (value: string, mode: 'create' | 'edit' | 'copy') => {
      const trimmed = value.trim()
      const hasDuplicate = Boolean(viewCache.find(trimmed))

      return validateDuplicateTitle({
        value,
        mode,
        defaultValue,
        hasDuplicate,
        t,
        errorKey: 'error.duplicateSearchAssistantTitle',
      })
    },
  }
}
